import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import './ImageValidator.scss';
import { ImageViewer } from '../../../UiKit';
import ImageValidationOptions from './ImageValidationOptions/ImageValidationOptions';
import WoApproveImage from './WoApproveImage/WoApproveImage';
import HandoverReasons from './HandoverReasons/HandoverReasons';
import { noRiderImage } from '../../../images/images';
import { VideoPlayer } from '../../../UiKit/videoPlayer/videoPlayer';
import { MultiMedia } from '../../../UiKit/multimedia/multimedia';

export default class ImageValidator extends Component {
  render() {
    const { handoverData } = this.props;
    return (
      <div className='imageValidatorContainer row'>
        {!handoverData ? (
          <Shimmer height='150px' width='100%' />
        ) : (
          <ImageValidatorComp {...this.props} />
        )}
      </div>
    );
  }
}

class ImageValidatorComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showStaticText: true,
      selectedBtn: {},
    };
  }
  getImages = (images) => {
    return (
      images &&
      images.map((image) => {
        if (image.image_path) {
          return { src: image.image_path, image_ref: image };
        } else {
          return { src: image };
        }
      })
    );
  };

  getSampleImages = (images) => {
    return (
      images &&
      images.map((image) => {
        return {
          src: image,
          label: 'sample',
        };
      })
    );
  };

  openTagDetails = (btn) => {
    if (btn.type === 'escalate') {
      const { sendAction, handoverData } = this.props;
      const { request_id } = handoverData;
      let data = {};
      data['request_id'] = request_id;
      Object.assign(data, btn.data);
      sendAction(data);
    } else {
      this.setState({
        selectedBtn: btn,
        showStaticText: false,
      });
    }
  };

  goBack = () => {
    this.setState({
      selectedBtn: {},
      showStaticText: true,
    });
  };

  render() {
    const { handoverData, sendAction, source = 'default' } = this.props;
    const { showStaticText, selectedBtn } = this.state;
    const {
      rider_images,
      is_fraud_concern_view,
      ordered_items,
      request_items,
    } = handoverData;
    let riderImages =
      rider_images && rider_images.length ? rider_images : [noRiderImage];

    let ImagesList = handoverData.media.map((img) => ({
      src: img?.url,
      type: img?.type,
    }));

    let productImages = ordered_items
      .filter((orederedItem) =>
        request_items.find(
          (requestItem) => requestItem?.id === orederedItem.item_id,
        ),
      )
      .map((i) => ({ ...i, src: i.image_url }));

    return (
      <div
        className={`imageValidator ${is_fraud_concern_view ? 'row' : 'col'} `}
      >
        <div className={`pb10 ${is_fraud_concern_view ? 'col' : 'row'}`}>
          <div className='imageContainer col'>
            <div className='lighter'>
              <span role='img' aria-label='customer'>
                🤴🏻
              </span>
              <span>{'\u00A0'}Customer’s photos/videos</span>
            </div>
            {ImagesList.length && (
              <MultiMedia
                images={ImagesList}
                title='Customer’s photos/videos'
              />
            )}
          </div>
          <div className='imageContainer col'>
            <div className='lighter'>
              {/* <span role='img' aria-label='customer'>
                🛵
              </span> */}
              <span>Product Images</span>
            </div>
            {riderImages && <ImageViewer images={productImages} />}
          </div>
        </div>
        {showStaticText && (
          <ImageValidationOptions
            handoverData={handoverData}
            openTagDetails={this.openTagDetails}
          />
        )}
        {selectedBtn && selectedBtn.type && (
          <div className='content'>
            {selectedBtn.type === 'approve' && source === 'wrongOrder' ? (
              <WoApproveImage
                handoverData={handoverData}
                goBack={this.goBack}
                sendAction={sendAction}
              />
            ) : (
              <HandoverReasons
                selectedBtn={selectedBtn}
                handoverData={handoverData}
                goBack={this.goBack}
                sendAction={sendAction}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}
